'use client';

import { useTranslations } from 'next-intl';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { ApplicationDangerSection, toasterApi } from '@terra/ui-design-system';
import { useDeleteApplicationTarget } from '../../../hooks/api/useDeleteApplicationTarget';
import { useReturnToWelcomeAfterTargetDelete } from './useReturnToWelcomeAfterTargetDelete';

type TargetDangerPanelProps = {
  applicationId: string;
  applicationName: string;
  targetType: TargetTypeType;
};

export function TargetDangerPanel({
  applicationId,
  applicationName,
  targetType,
}: TargetDangerPanelProps) {
  const t = useTranslations('designSystem.applicationSettings.danger');
  const returnToWelcome = useReturnToWelcomeAfterTargetDelete();
  const deleteTarget = useDeleteApplicationTarget();

  const handleDelete = async () => {
    try {
      await deleteTarget.mutateAsync({ applicationId, targetType });
      toasterApi.success({ title: t('deleteSuccess') });
      returnToWelcome();
    } catch (error) {
      console.error(
        new Error('Failed to delete application target', {
          cause: error instanceof Error ? error : new Error(String(error)),
        }),
      );
      toasterApi.error({
        title: t('deleteError'),
        description: error instanceof Error ? error.message : undefined,
      });
    }
  };

  return (
    <ApplicationDangerSection
      applicationName={applicationName}
      onDelete={handleDelete}
      isDeleting={deleteTarget.isPending}
    />
  );
}
